module.exports = __webpack_public_path__ + "img/exp-4.7943d651.png";